/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export class ConfigurationLocationActionNames {

    static GetFolder = (): string => '[Configuration Location] GetFolderPath';

    static GetFolderSuccess = (): string => '[Configuration Location] GetFolder Success';
}